import {FormHelperText, TableBody} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';

const useStyles = makeStyles(theme => ({
  tableRowSpacing: {
    padding: '0px 0px 0px 20px',
    borderBottom: 'none',
    align: 'left',
  },
}));

const VCConfirmation = () => {
  const classes = useStyles();
  const {viewCart, shippingPriority} = useSelector((state: ReducerState) => state.marketing);

  return (
    <div style={{width: '90%', marginLeft: '1rem'}}>
      <FormHelperText className="border-bottom-confirmation" style={{fontWeight: 'bold', fontSize: '1rem'}}>
        Forms Ordered:
      </FormHelperText>

      <Table aria-label="simple table" size="small">
        <TableBody>
          {Array.from(viewCart.items.keys()).map(k => (
            <TableRow className="confirmation-table" key={k}>
              <TableCell className={classes.tableRowSpacing}>{k}</TableCell>
              <TableCell className={classes.tableRowSpacing}>{viewCart.items.get(k)?.title}</TableCell>
              <TableCell className={classes.tableRowSpacing}>{viewCart.items.get(k)?.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <br />

      <FormHelperText className="border-bottom-confirmation" style={{fontWeight: 'bold', fontSize: '1rem'}}>
        Ship to:
      </FormHelperText>
      <Table aria-label="simple table" size="small">
        <colgroup>
          <col width="50%" />
          <col width="50%" />
        </colgroup>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Company:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.company}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Name:</TableCell>
            <TableCell className={classes.tableRowSpacing}>
              {viewCart.firstName} {viewCart.lastName}
            </TableCell>
          </TableRow>

          {viewCart.costCenter && (
            <TableRow>
              <TableCell className={classes.tableRowSpacing}>Cost Center:</TableCell>
              <TableCell className={classes.tableRowSpacing}>{viewCart.costCenter}</TableCell>
            </TableRow>
          )}

          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Address Line 1: </TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.address}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Address Line 2: </TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.address2}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>City:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.city}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>State:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.state}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Zip:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.zip}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Phone Number:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.phoneNumber}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Email:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{viewCart.email}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <br />
      <FormHelperText className="border-bottom-confirmation" style={{fontWeight: 'bold', fontSize: '1rem'}}>
        Shipping:
      </FormHelperText>
      <Table aria-label="simple table" size="small">
        <colgroup>
          <col width="50%" />
          <col width="50%" />
        </colgroup>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Shipping Method:</TableCell>
            <TableCell className={classes.tableRowSpacing}>{shippingPriority}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>FedEx Account Name:</TableCell>
            <TableCell className={classes.tableRowSpacing}>
              {viewCart.fedExName !== undefined && shippingPriority !== 'Standard' ? viewCart.fedExName : 'NA'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>FedEx Account Number: </TableCell>
            <TableCell className={classes.tableRowSpacing}>
              {viewCart.fedExNumber !== undefined && shippingPriority !== 'Standard' ? viewCart.fedExNumber : 'NA'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableRowSpacing}>Instructions:</TableCell>
            <TableCell className={classes.tableRowSpacing}>
              {viewCart.instructions !== '' ? viewCart.instructions : 'No instructions'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default VCConfirmation;
